import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTarjetaValidator]',
})
export class TarjetaValidatorDirective {
  private regex: RegExp = new RegExp(/^\d{0,16}$/);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value.replace(/\D/g, '');
    let next: string = current.concat(event.key);

    if (!this.regex.test(next) || next.length > 16) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value.replace(/\D/g, ''); // Remove all non-digit characters

    if (value.length > 16) {
      value = value.substring(0, 16); // Trim to 16 characters
    }

    inputElement.value = value;
  }
}
